import React from 'react';
import { ConfirmationDialogV2 } from '@/components/custom/erp';

interface UndoConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  content?: string;
}

const UndoConfirmDialog = ({ open, onClose, onConfirm, title = 'Hỏi' }: UndoConfirmDialogProps) => {
  return <ConfirmationDialogV2 open={open} onClose={onClose} onConfirm={onConfirm} title={title} />;
};

export default UndoConfirmDialog;
